import { SendMessagePayload } from './useSendComment.interface';

import { sendDatadogRumError } from 'utils/analytics/datadogRum';
import zendeskGateway from 'services/help-center/zendeskBackendGateway';
import {
    Audit,
    Ticket,
} from 'modules/IMC/MessageCenter/components/MessageCenterContent/MessageList/MessageList.interface';

const sendMessage = async (ticketId: number, payload: SendMessagePayload) => {
    try {
        const response = await zendeskGateway.put<{ audit: Audit; ticket: Ticket }>(`/tickets/${ticketId}`, payload);
        return response.data;
    } catch (error) {
        sendDatadogRumError('sendMessage', error, { source: 'sendMessage', ticketId, payload });
        throw error;
    }
};

export default sendMessage;
